import { Component, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

import { AppService } from '@app/app.service';
import { AuthService } from '@app/auth/auth.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-user-password-change',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatTooltipModule
],
  standalone: true,
  templateUrl: './user-password-change.component.html',
  styleUrl: './user-password-change.component.scss'
})
export class UserPasswordChangeComponent {

  passwordForm: FormGroup;
  passwordMinLength = 5;

  hideCurrent = signal(true);
  hideNew = signal(true);

  constructor(
    private fb: FormBuilder, 
    private appService: AppService,
    private authService: AuthService,
    private router: Router,
  ) {

    this.passwordForm = this.fb.group({
      password: ['', [Validators.required]],
      new_password: ['', [Validators.required, Validators.minLength(this.passwordMinLength)]],
    });

  }

  updatePassword() {

    if(this.passwordForm.invalid) {
      this.appService.showSnackBar('Please fill in all required fields', 'error');
      return;
    }
    
    this.authService.updateUserPassword(this.passwordForm.value).subscribe({
      next: (response) => {
        this.appService.showSnackBar(response.message, 'success');
        this.router.navigate(['/account']);
      },
      error: (error) => {
        this.appService.handleError(error);
      }
    });
  }

  goBack() {
    this.router.navigate(['/account']);
  }

}
